import '.cl{font-size:1.125rem;}.ssr-plugin'
import '.gj{line-height:1.75rem;}.ssr-plugin'
import '.c5{text-decoration:none;}.ssr-plugin'
import '.eg{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="cl gj"
    >
      {translations.privacySubtitle}{' '}
      <a className="c5 eg"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="c5 eg"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
